import { render, staticRenderFns } from "./BandPreview.vue?vue&type=template&id=03858085&"
import script from "./BandPreview.vue?vue&type=script&lang=js&"
export * from "./BandPreview.vue?vue&type=script&lang=js&"
import style0 from "./BandPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BandPreview.vue"
export default component.exports